/* eslint-disable */
// src/layouts/local/index.js

import React, { useState, useEffect, useMemo, useCallback } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useMaterialUIController } from "context";

import localTableData from "layouts/local/data/localTableData";

import localService from "services/localService";
import CreateLocalForm from "../../forms/local/createLocalForm";
import UpdateLocalForm from "../../forms/local/updateLocalForm";

import AppFormDialog from "components/common/AppFormDialog";
import Button from "@mui/material/Button";
import AppSnackbar from "components/common/AppSnackbar";
import { useNavigate, useLocation } from "react-router-dom";

function Local() {
  const navigate = useNavigate();
  const location = useLocation();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [localsDetails, setLocalsDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createDialogTitle, setCreateDialogTitle] = useState("Agregar local");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [localToEdit, setLocalToEdit] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });

const load = useCallback(async () => {
  setIsLoading(true);
  try {
    const localsDetailsData = await localService.getActiveComercioWithOwners();
    setLocalsDetails(localsDetailsData || []);
  } catch (error) {
    console.error("Error fetching locals:", error);
    setLocalsDetails([]);
  } finally {
    setIsLoading(false);
  }
}, []);

 // refresca cada vez que entrás a la página (navegación)
  useEffect(() => {
    load();
  }, [load, location.key]);

  useEffect(() => {
    const navSnack = location.state?.snack;
    if (!navSnack) return;

    setSnack({
      open: true,
      severity: navSnack.severity || "success",
      message: navSnack.message || "",
    });

    navigate(
      {
        pathname: location.pathname,
        search: location.search || "",
        hash: location.hash || "",
      },
      { replace: true, state: null }
    );
  }, [location, navigate]);

// refresca al volver al tab/ventana (sin botón)
  useEffect(() => {
    const onFocus = () => load();
    const onVisibility = () => {
      if (document.visibilityState === "visible") load();
    };

    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [load]);


  // agrupamos solo por departamento 
  const groupedByDepartment = useMemo(() => {
    const groups = {};
    (localsDetails || []).forEach((local) => {
      const dept = local.Department || "Sin departamento";
      if (!groups[dept]) groups[dept] = [];
      groups[dept] = [...groups[dept], local];
    });
    return groups;
  }, [localsDetails]);

  // Destino compartido por el enlace del nombre del local.
  const getLocalDetailsDestination = (local) => {
    const id = local.Id ?? local.LocalId;
    return {
      pathname: `/local/${id}`,
      state: {
        local,
        returnTo: {
          pathname: location.pathname,
          search: location.search || "",
          hash: location.hash || "",
          state: location.state ?? null,
        },
      },
    };
  };

  const handleOpenCreateModal = () => {
    setCreateDialogTitle("Agregar local");
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
    setCreateDialogTitle("Agregar local");
  };

  const handleOpenEditModal = (localId) => {
    const local = (localsDetails || []).find((l) => (l.Id ?? l.LocalId) === localId);
   if (!local) return;

   // Adaptamos al shape que UpdateLocalForm espera (plano)
   const localForForm = {
     Id: local.Id ?? local.LocalId,
     Name: local.Name,
     Address: local.Address,
     City: local.City,
     Department: local.Department,
   };

   setLocalToEdit(localForForm);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setLocalToEdit(null);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6} rowSpacing={3}>
          {/* Encabezado con botones */}
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Locales
                </MDTypography>
                <MDBox display="flex" gap={1}>
                  <Button color="inherit" onClick={handleOpenCreateModal}>
                    Agregar local
                  </Button>
                  <Button color="inherit" onClick={() => navigate("/local/inactive")}>
                    Ver locales inactivos
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          {/* Un card por departamento, dentro listas por ciudad */}
          {Object.entries(groupedByDepartment).map(([department, deptLocals]) => {
            // agrupamos locales del departamento por ciudad
            const groupedByCity = (deptLocals || []).reduce((acc, local) => {
              const city = local.City || "Sin ciudad";
              if (!acc[city]) acc[city] = [];
              acc[city].push(local);
              return acc;
            }, {});

            const sortedCities = Object.keys(groupedByCity).sort((a, b) =>
              a.localeCompare(b, "es")
            );

            return (
              <Grid item xs={12} key={department}>
                <Card sx={{ p: 2 }}>
                  {/* header del departamento */}
                  <MDBox
                    mb={1.5}
                    px={1.5}
                    py={1.25}
                    borderRadius="md"
                    bgColor={darkMode ? "#263E5B" : "#CCE2F7"}
                  >
                    <MDTypography
                      variant="h6"
                      color="inherit"
                      fontWeight="bold"
                      sx={{ fontSize: "20px", color: darkMode ? "#E4F0FC" : "#174A78" }}
                    >
                      {department}
                    </MDTypography>
                  </MDBox>

                  {/* para cada ciudad, un subtítulo + tabla propia */}
                  <MDBox>
                    {sortedCities.map((city, cityIndex) => {
                      const cityLocals = groupedByCity[city];

                      const { columns, rows } = localTableData({
                        localsDetails: cityLocals,
                        onEdit: handleOpenEditModal,
                        onDetails: getLocalDetailsDestination,
                        darkMode,
                      });

                      return (
                        <MDBox
                          key={`${department}-${city}`}
                          pt={cityIndex === 0 ? 0 : 2}
                        >
                          <MDBox
                            px={1.5}
                            py={1}
                            bgColor={darkMode ? "#2B3548" : "#E8EBEF"}
                            sx={{ borderBottom: `1px solid ${darkMode ? "#46546C" : "#DEE2E6"}` }}
                          >
                            <MDTypography
                              variant="button"
                              fontWeight="medium"
                              color="inherit"
                              sx={{ display: "block", fontSize: "18px", textTransform: "none", color: darkMode ? "#EDF2F8" : "#344767" }}
                            >
                              {city}
                            </MDTypography>
                          </MDBox>

                          <MDBox
                            sx={({ palette }) => ({
                              "& table": { tableLayout: "fixed", width: "100%" },
                              "& thead": {
                                position: "absolute",
                                width: 1,
                                height: 1,
                                padding: 0,
                                margin: -1,
                                overflow: "hidden",
                                clip: "rect(0, 0, 0, 0)",
                                clipPath: "inset(50%)",
                                whiteSpace: "nowrap",
                                border: 0,
                              },
                              "& th:first-of-type, & td:first-of-type": {
                                width: "calc(100% - 64px)",
                                padding: "8px 8px 8px 12px",
                              },
                              "& th:nth-of-type(2), & td:nth-of-type(2)": {
                                width: "64px",
                                padding: "8px 0 8px 8px",
                              },
                              "& td:first-of-type > div": {
                                width: "100%",
                                maxWidth: "100%",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                              },
                              "& tbody tr:not(:last-child) td": {
                                borderBottom: `1px solid ${darkMode ? "#3B4A63" : palette.grey[300]}`,
                              },
                              "& tbody tr:last-child td": {
                                borderBottom: "none",
                              },
                            })}
                          >
                            <DataTable
                              table={{ columns, rows }}
                              isLoading={isLoading}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </MDBox>
                      );
                    })}
                  </MDBox>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </MDBox>
      <Footer />

      <AppFormDialog open={isCreateModalOpen} onClose={handleCloseCreateModal} title={createDialogTitle} maxWidth="md">
          <CreateLocalForm
            closeForm={handleCloseCreateModal}
            navigate={navigate}
            onStepChange={(step, ownerName) => {
              setCreateDialogTitle(step === 2 && ownerName ? `Agregar local de ${ownerName}` : "Agregar local");
            }}
          />
      </AppFormDialog>

      {localToEdit && (
        <AppFormDialog
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          title={localToEdit.Name ? `Editar local ${localToEdit.Name}` : "Editar local"}
          maxWidth="md"
        >
            <UpdateLocalForm 
              closeForm={handleCloseEditModal}
              local={localToEdit}
              onSaved={load}
            />
        </AppFormDialog>
      )}

      <AppSnackbar
        open={snack.open}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        severity={snack.severity}
        message={snack.message}
      />
    </DashboardLayout>
  );
}

export default Local;
